export enum UserType {
    INTERNAL = 'INTERNAL',
    ORGANIZATION = 'ORGANIZATION',
}
